import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage9(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(refs.prayer.title.current, { alpha: 1, scale: 1, duration: 1 }, 'stage9')
    .to(refs.prayer.content.current, { alpha: 1, scale: 1, duration: 1 }, 'stage9')
    .to(refs.prayer.info.current, { alpha: 1, y: 0, duration: 1 }, 'stage9');

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage9',
    animations: [
      { x: vw(-0.244), y: vh(-0.225), duration: 1 },
      { x: vw(0.171), y: vh(-0.205), duration: 1 },
      { x: vw(-0.46), y: vh(-0.355), duration: 1 },
      { x: vw(0.436), y: vh(-0.362), duration: 1 },
      { x: vw(0.322), y: vh(-0.586), duration: 1 },
      { x: vw(-0.21), y: vh(-0.595), duration: 1 },
    ],
  });
}
